<template>
  <div>
    <form>
      <el-button
        v-if="$attrs.row[$attrs.column] != '404'"
        class="md-raised md-danger"
        type="submit"
        @click="downloadFile($attrs.row[$attrs.column])"
        ><i class="el-icon-download"></i> / <i class="el-icon-view"></i>
      </el-button>
    </form>
    <viewPdf ref="details" />
  </div>
</template>

<script>
import viewPdf from "@/components/customers/CustomerAccountStatus.vue";
export default {
  name: "DownloadFile",
  components: {
    viewPdf
  },
  data: () => ({
    file: "",
    files: ""
  }),
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    downloadFile(file) {
      this.$refs.details.callNew(file);
    }
  }
};
</script>
